import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomLoggerService } from '../../custom-logging/custom-logger.service';
type TTagScannerResponse = {
  status: boolean;
  data: Record<string, string>;
  error?: string;
  errorTitle?: string;
};
@Injectable({
  providedIn: 'root',
})
export class ScannerDataFormatter {
  private legacyTagKeyPrefix = '_n.c.k_';
  private legacyTagValuePrefix = '_n.c.v_';

  constructor(private translate: TranslateService, private logger: CustomLoggerService) {}

  private createJsonFromKeyValue(keys: string[], values: string[]): TTagScannerResponse {
    if (keys.length !== values.length) {
      return {
        status: false,
        data: {},
        error: this.translate.instant('scanner_data_formatter.differentLengthError.message'),
        errorTitle: this.translate.instant('scanner_data_formatter.differentLengthError.header'),
      };
    }
    const codeJson: Record<string, string> = {};
    keys.forEach((k, idx) => {
      codeJson[k] = values[idx].replace(/"/g, '');
    });
    return {
      status: true,
      data: codeJson,
    };
  }

  //This is both v1 and v2
  decodeLegacyTagData(tagData: string) {
    try {
      const arr = tagData.split(this.legacyTagKeyPrefix);
      const allKandV = arr[1].split(this.legacyTagValuePrefix);
      const keys = allKandV[0].split(',');
      const values = allKandV[1].split(',');
      return this.createJsonFromKeyValue(keys, values);
    } catch (e) {
      return {
        status: false,
        data: {},
        error: this.translate.instant('scanner_data_formatter.differentLengthError.message'),
        errorTitle: this.translate.instant('scanner_data_formatter.differentLengthError.header'),
      };
    }
  }

  decodeV3TagData(valueArr: string[]) {
    const keyNames: string[] = [
      'id',
      'did',
      'byr',
      'sty',
      'po',
      'clr',
      'shd',
      'sz',
      'orf',
      'qty',
      'bn',
      'cut',
      'sr',
      'cat',
      'oid',
      'pt',
    ];
    try {
      //BackTick at first character of index 1 refer Uppercase
      if (valueArr[1].startsWith('`')) {
        //Omit the BackTick character at index 1
        valueArr[1] = valueArr[1].slice(1);
        //index zero represents tagId
        for (let i = 1; i < valueArr.length; i++) valueArr[i] = valueArr[i].toUpperCase();
      }
      return this.createJsonFromKeyValue(keyNames, valueArr);
    } catch (error) {
      return {
        status: false,
        data: {},
        error: this.translate.instant('scanner_data_formatter.parsingScannedTagsError'),
      };
    }
  }

  decodeTagString(tagData: string): TTagScannerResponse {
    try {
      let decodedJson: null | TTagScannerResponse = null;
      this.#logTagDataToNgxLogger(tagData);
      if (tagData.includes(this.legacyTagKeyPrefix) && tagData.includes(this.legacyTagValuePrefix)) {
        return this.decodeLegacyTagData(tagData);
      } else {
        let valueArr = tagData.split(',');
        //Zero index represent version
        const version = parseInt(valueArr[0].slice(1));
        //Omiting the version value at index 0
        valueArr = valueArr.slice(1);
        switch (version) {
          case 3:
            decodedJson = this.decodeV3TagData(valueArr);
            break;
          default:
        }
      }
      if (decodedJson) return decodedJson;
      else {
        return {
          status: false,
          data: {},
          error: this.translate.instant('scanner_data_formatter.parsingScannedTagsError'),
        };
      }
    } catch (e) {
      return {
        status: false,
        data: {},
        error: this.translate.instant('scanner_data_formatter.parsingScannedTagsError'),
      };
    }
  }

  #logTagDataToNgxLogger(tagData: string) {
    this.logger.log('SCANNER_DATA_FORMATTER', 'RAW TAG DATA', {
      rawTagData: JSON.stringify(tagData),
      rawTagDataLength: tagData.length,
      last30Chars: tagData.slice(-30),
    });
  }
}
